import cn from "classnames"

import { Flex, Text } from "@/atoms"
import { Icon, Line, NumberLabel } from "."

import styles from "./Flow.module.scss"

import type { LabelCollapseProps } from "./Flow.types"

export const LabelCollapse = (props: LabelCollapseProps) => {
  const isSecondary = props.variant === "secondary"
  const { start, end } = props
  const showNumber = (start && !end) || (!start && end)
  const showIcon = start && end
  const showLine = !showIcon && start
  const isPrimary = props.variant === "primary"

  return (
    <Flex align="center" gap={16}>
      <Flex className={cn(!isSecondary && styles.numberContainer)}>
        {showNumber && props.value && <NumberLabel value={props.value} />}
        {showLine && <Line isFalsePositive={props.isFalsePositive} />}
        {showIcon && (
          <div className={styles.numberWrapper}>
            <Icon isFalsePositive={props.isFalsePositive} />
          </div>
        )}
      </Flex>
      <Flex
        flex={1}
        gap={32}
        align="center"
        className={cn(!isSecondary && styles.labelContent)}
      >
        <Flex vertical flex={1}>
          <span
            className={cn(styles.text, {
              [styles.titlePrimary]: isPrimary,
              [styles.titleSecondary]: isSecondary,
              [styles.text8]: props.variant === "third"
            })}
          >
            {props.title}
          </span>
          {props.description && (
            <Flex gap={4}>
              <Text
                ellipsis={isPrimary}
                className={cn(styles.text, {
                  [styles.textSecondary]: !isSecondary
                })}
              >
                {props.description}
              </Text>
              {props.line && (
                <Text
                  className={cn(
                    styles.text,
                    styles.textSecondary,
                    styles.textNowrap
                  )}
                >{`Line:${props.line}`}</Text>
              )}
            </Flex>
          )}
          {props.children}
        </Flex>
        {props.extra && <span>{props.extra}</span>}
      </Flex>
    </Flex>
  )
}
